<template>
	<div>
		<!-- swiper 插件 轮播图 -->
		<div class="banner">
			<img :src="pageData.banner" alt="">
			<div class="title">{{pageData.title}}</div>
		</div>
 
		<!-- 内容容器 -->
		<div class="content-wrapper">
			<section class="data0" v-if="params.type === 'newBusiness'">
				<div class="content">
          <div class="lists">
            <template v-for="(item, index) in pageData.data0.lists">
              <div class="item" :class="{'left': index==0}" :key="index" v-if="index < 3">
                <img :src="item.imgUrl" alt="">
                <div class="title">{{item.title}}</div>
                <div class="date">{{item.updateTime}}</div>
              </div>
            </template>
          </div>
				</div>
			</section>
      <section class="data1" v-if="params.type === 'newBusiness'">
				<div class="content" v-if="pageData.data0.lists.length > 3">
          <div class="lists">
            <template v-for="(item, index) in pageData.data0.lists">
              <div class="item" :key="index" v-if="index >= 3">
                <img :src="item.imgUrl" alt="">
                <div class="text-box">
                  <div class="title">{{item.title}}</div>
                  <div class="date">{{item.updateTime}}</div>
                  <div class="desc">
                    <div>{{item.desc}}</div>
                    <span class="more-box">查看更多</span>
                  </div>
                </div>
              </div>
            </template>
          </div>
				</div>
			</section>
      <section class="data2">
				<div class="content">
          <div class="lists">
            <template v-for="(item, index) in pageData.data2.lists">
              <div class="item" :key="index" @click="openPage(`details/${item.id}`)">
                <img :src="item.imgUrl" alt="">
                <div class="text-box">
                  <div class="title border">{{item.title}}</div>
                  <div class="desc">{{item.desc}}</div>
                  <span class="more-box" >查看详情</span>
                </div>
                <div class="date">
                  <div class="date1">{{handleSliceStr(item.updateTime, 8, 10) > 10 ? handleSliceStr(item.updateTime, 8, 10) : handleSliceStr(item.updateTime, 9, 10) }}</div>
                  <div class="date2">{{handleSliceStr(item.updateTime, 0, 7)}}</div>
                </div>
              </div>
            </template>
          </div>
				</div>
			</section>
			<div class="more-tip" v-if="!lastPage" @click="casePage()">点击加载更多</div>
			<div class="more-tip" v-if="noMore">没有更多了</div>

		</div>
	</div>
</template>

<script>
  import Swiper from 'swiper';
	import { casePage, companyItemList, bannerList, indexDataList, getAppInfo, itemList } from '@/utils/api';

	export default {
		name: 'NewConsult',
		props: {},
		components: {},
		data() {
			return {
				screenWidth: 0,
				screenHeight: 0,
				activeNav: 'new',
				pageData: {
					banner: '',
					title: '行业资讯',
					// 我的服务
					data0: {
            content: '',
            lists: [],
          },
          data2: {
            content: '',
            lists: [],
          }
				},
				data2Index: 0,
				serviceIndex: 0,
        params: { type: 'newConsult' },
				isLoading: false,
				noMore: false,
        pageNum: 1,
        lastPage: false,
			};
		},
		components: {},
		created() {
			this.$store.commit('activeNav', 'new');
      this.init();
		},
		computed: {
		},
		mounted() {},
		methods: {
      async init() {
        const res = await getAppInfo('key-info-case-bg-imgUrl2');
        this.pageData.banner = res.data.baseData.content;
        console.log('new--res==', res);

        // const res1 = await this.casePage();
        // const lists = res1.list.filter(d => d.isShow);
        // this.pageData.data0.lists = lists || [];
        // console.log('new--res1==', res1);

        const res2 = await this.casePage(1);
        this.pageData.data2.lists = res2.list || [];
        console.log('new--res2==', res2);

        this.$set(this, 'pageData', this.pageData);
        console.log('new--this.pageData==', this.pageData);
      },
      async casePage(page) {
				console.log('new--consult--casePage--page==', page, this.lastPage, this.isLoading);
				if (this.lastPage || this.isLoading) {
          return;
        }
        this.isLoading = true;
				const payload = {
          type: 2,
					page: page || this.pageNum + 1
				};
				const res = await casePage(payload);
				console.log('new--business--casePage--res==', res);
				if (payload.page > 1) {
					const baseData = res.data.baseData;
					this.lastPage = baseData.lastPage;
					const list = baseData.list || [];
					if (baseData.firstPage) {
						this.pageData.data2.lists = list;
					} else {
						this.pageData.data2.lists = this.pageData.data2.lists.concat(list);
					}
					if (this.lastPage) {
						this.noMore = true;
					}
					this.$set(this, 'pageData', this.pageData);
				}
				this.isLoading = false;
				return res.data.baseData;
      },
      openPage(url) {
        let cur_route = this.$route.path
        if (cur_route == url) {
          return;
        }
        this.$router.push(url);
      },
			changeNav(item) {
				console.log('changeNav--item==', item);
				if (item.id === 'product') {
					// this.showProductMenu = !this.showProductMenu;
					this.showProductMenu = true;
				} else {
					this.showProductMenu = false;
				}
				this.activeNav = item.id;
				// this.$router.push({path: '/pages/product'})
			},
			changeServiceIndex(index) {
				this.serviceIndex = index;
			},
			handleOpen(e) {
				console.log('handleOpen--e==', e);
			},
			handleClose(e) {
				console.log('handleClose--e==', e);
			},
			handleSliceStr(str, start = 0, end) {
				var str1 = JSON.parse(JSON.stringify(str));
				if (!str) {
					return '';
				}
				if (!end || end > str.length) {
					end = str.length;
				}
				return str1.slice(start, end);
			},
			// changeData2Index(num) {
			//   const max = Math.ceil(this.pageData.data2.lists.length / 4);
			//   console.log('changeData2Index--max==', max);

			//   if (num > 0 && this.data2Index < max) {
			//     this.data2Index += num;
			//   } else if (num < 0 && this.data2Index > 0) {
			//     this.data2Index += num;
			//   }
			// }
		}
	}
</script>

<style scoped lang="scss">
@import '../common/css/new.scss';
</style>



// WEBPACK FOOTER //
// src/pages/newConsult.vue